import parse from 'date-fns/parse';

export const parseServerDate = (date: string) => {
  return parse(date as string, 'd.M.yy', new Date());
};
